import React, {useState, useEffect} from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import Product from './Product';
import './Products.scss';
import { api } from '../../../utilities/fetch';
import { useStateValue } from '../../../utilities/StateProvider';

export default function ProductsList(props) {

    const [products, setProducts] = useState([]);
    const [groupCart, setGroupCart] = useState({});
    const [ {cart}, dispatch ] = useStateValue();

    useEffect(() => {
        const getProducts = async (type) => {
            const categoryList = await api.get(`categories`);
            const groupedList = categoryList.data.map(async (entry) => {
                const list = await api.get(`${type}?categories=${entry.id}`);
                return {name: entry.name, products: list.data, slug: entry.slug, sort: entry.order};
            });
            const productList = await Promise.all(groupedList);
            setProducts(productList);
        }
        getProducts(props.type);
    }, []);

    const addToCart = () => {
        const newCart = {
            ...cart,
            ...groupCart
        }

        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    const renderProductsList = () => {
        products.sort((a, b) => (a.sort - b.sort));

        return (
            products
            .filter(entry => (entry.products.length > 0))
            .map((entry, index) => entry.products.length && renderProductGroup(entry.name, entry.products, entry.slug, index))
        );
    }

    const renderProductGroup = (name, products, slug, index) => {
        products.sort((a, b) => (a.id - b.id));

        return (
            <React.Fragment key={index}>
                <div className="divisor" />
                <Container>
                    <Row>
                        <Col className="title">{name}</Col>
                    </Row>
                    <Row className="product-category justify-content-center">
                        {products.map((entry, index) => (
                            <Col xs="6" md="3" key={index}>
                                <Product data={entry} category={{name, slug}} type={props.type}
                                    groupCart={groupCart} setCart={setGroupCart}/>
                            </Col>
                        ))}
                    </Row>
                    <Row>
                        <Button className="shop-button cart" onClick={addToCart}>Agregar<br/>al Carrito</Button>
                    </Row>
                </Container>
            </React.Fragment>
        )
    }

    return (
        <Container>
            <Row>
                {renderProductsList()}
            </Row>
        </Container>
    )
}
